/*
  Dermastart smart search.
  Cleans up queries before they reach Shopify search so customers don't need exact wording:
  - strips punctuation and trademark symbols, collapses spacing
  - applies the "Search rewrites" list from Theme settings > Search
  - splits run-together words ("stemcell" -> "stem cell") and joins split brand names ("copper gen" -> "coppergen")
    using a vocabulary of product-title words (regenerate VOCAB when the catalog changes a lot)
  - on the search page, shows a "showing results for" notice and "did you mean" products when nothing matches
*/
(function () {
  var VOCAB = new Set('120ml 12pk 15ml 16oz 16th 1oz 2oz 30ml 32oz 3pack 4ml 4oz 50ml 54oz 5oz 5th 6oz 75oz 7oz 8oz 9th acid acne activator active advanced after age agevity aging aha aid alpha am ampoules and anti antimicrobial antioxidant apple aqua arnica as at avl away azelaic b5 back badging balance balms ban banacne barrier bb beauty becomes beet best beyond bha bikini bio biome black blemish blend blood bloom body bond booster boosters boots bottle bottom box boxes bp brickhouse bride bright brighten brightening brite brow brows brush buff bundle by calming care cause celebration cell cellular certificate ceuticals cheeks chest choice chronic clarity clay clean cleanse cleanser cleansing clear clearance clearbalance clearchoice clearify clenz clini collection color complex complexion condition connection cool cooling copper copperderm coppergen copperice coppertide corporate correction council cover cr cramp cream creme crinkle cu currency cushion dance deep defense defying demand derm dermabrasion dermal dermaplane dermatician detox dewy digital dimple dirty disco discontinued discontinuing dn don dose down drops edition education elimaderm enhancers environment enzyme esthetics even exfoliating extension extraction extractions extreme eye eyedeal eyes facial factor fanny fatigue fever firming flare flower fluids foam foaming fog follicle fox free freeze fri friction frixtion gel gen gentle gentlemen ghost ginger glow gly glybright glycolic gogo gravity green greybiotics guard haa hair hand healing heart heavy helios hello home hoo hot hyaluronate hydrating hydro hylascalp hyper hyperpigmentation ii iii illusion individual inflammation intense intim intimate intimprep iso isomer iv jelly jessner jewel july kaleidoscope kick kisses kit known lacti lactibiome lactic laser lash level lid lift lifting light limited lip lipid lips lotion love lumi lumienzyme lumilacti man manage mandelic manup marine mask masque massage mastering matcha matrix md me medicated medium melanin men menopause method micro midnight milk milky mini mist moisture moisturizer multi mushroom my natural neuro neurogenic neutralizing new night no noir nourishing november nucleanse nude o2 ocu ocuclenz oil on one op opal operation opti order organic out oz pack package pads pants papaya patch patches pdrn peach pearly peel peeling peels peppy peptide phantom phresh phyto pimple pink pinkism pits pk plus pm pms point polish pore post postcard powder power pre precious prenatal prep previously prickly primer print professional prone pumpkin punch purchase pure purple quench rbc reactive reconstructive recovery refining reflect rehab reishi relief remodel renewal repair replenish resist restore resurfacing retinol retinox revital revitalize rewind rich roll room root routine sachet sachets safe safer saffron sample sanitizer scalp scalpify sea seasonal self sensi sensitive sensory serum shadow shampoo sheet shield shokolad side sidekick signal silk skin sleeping smarter sodium solution sonic soothing special specialist spf splash sport spot spray stem stix stone stratum sun sunkissed suppressant sync system take tanning tar tca tea teal techniques the therapy thermal through tide time timeless tone toner tonic training trauma treasure treatment trial truffle tumwater tx under undercover up urban vajacial vat veggie vita vital vitamin volcanic vr wash washington watermelon wellness when winner wipes with wrinkle xr xtion yellow'.split(' '));
  var SHORT_TAILS = { a: 1, b: 1, c: 1, e: 1, k: 1 };

  function clean(q) {
    return (q || '').toLowerCase()
      .replace(/[™®©]/g, '')
      .replace(/[‘’']/g, '')
      .replace(/[^a-z0-9%]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseRewrites(text) {
    return (text || '').split(/\n/).map(function (line) {
      var parts = line.split('=>');
      if (parts.length !== 2) return null;
      var from = clean(parts[0]), to = parts[1].trim();
      return from && to ? { from: from, to: to.toLowerCase() } : null;
    }).filter(Boolean).sort(function (a, b) { return b.from.length - a.from.length; });
  }

  var REWRITES = parseRewrites(window.DSSearchRewrites);

  function applyRewrites(q) {
    var padded = ' ' + q + ' ';
    REWRITES.forEach(function (r) {
      padded = padded.split(' ' + r.from + ' ').join(' ' + r.to + ' ');
    });
    return padded.trim();
  }

  function split(token) {
    if (VOCAB.has(token) || token.length < 6 || /\d/.test(token)) return token;
    for (var i = token.length - 1; i >= 3; i--) {
      var a = token.slice(0, i), b = token.slice(i);
      if (VOCAB.has(a) && (VOCAB.has(b) && b.length >= 3 || SHORT_TAILS[b])) return a + ' ' + b;
    }
    return token;
  }

  function join(tokens) {
    var out = [];
    for (var i = 0; i < tokens.length; i++) {
      var a = tokens[i], b = tokens[i + 1];
      if (b && VOCAB.has(a + b) && !(VOCAB.has(a) && VOCAB.has(b))) { out.push(a + b); i++; }
      else out.push(a);
    }
    return out;
  }

  function normalize(q) {
    var c = clean(q);
    if (!c) return q;
    c = applyRewrites(c);
    var tokens = join(c.split(' ')).map(split);
    return tokens.join(' ');
  }

  window.DSSearch = { normalize: normalize, clean: clean };

  function isSearchForm(form) {
    var action = form.getAttribute('action') || '';
    return /\/search\/?$/.test(action) && form.querySelector('input[name="q"]');
  }

  function ensureHidden(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || !isSearchForm(form)) return;
    var input = form.querySelector('input[name="q"]');
    var original = input.value.trim();
    var fixed = normalize(original);
    ensureHidden(form, 'options[prefix]', 'last');
    if (fixed && clean(fixed) !== clean(original)) {
      input.value = fixed;
      ensureHidden(form, 'oq', original);
    }
  }, true);

  // Search results page extras
  var params = new URLSearchParams(window.location.search);
  if (!/\/search\/?$/.test(window.location.pathname) || !params.get('q')) return;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var q = params.get('q');
    var oq = params.get('oq');
    var notice = document.querySelector('[data-ds-search-notice]');
    if (notice && oq && clean(oq) !== clean(q)) {
      var rawParams = new URLSearchParams(window.location.search);
      rawParams.set('q', oq);
      rawParams.delete('oq');
      rawParams.delete('page');
      notice.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'ds-search-notice';
      p.appendChild(document.createTextNode('Showing results for “' + q + '”. '));
      var a = document.createElement('a');
      a.href = window.location.pathname + '?' + rawParams.toString();
      a.textContent = 'Search instead for “' + oq + '”';
      p.appendChild(a);
      notice.appendChild(p);
    }

    var fallback = document.querySelector('[data-ds-search-fallback]');
    if (!fallback) return;
    var base = (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.search_url) || '/search';
    var fields = 'title,product_type,variants.title,vendor,tag,body';

    function suggest(term) {
      var url = base + '/suggest.json?q=' + encodeURIComponent(term)
        + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=' + fields;
      return fetch(url).then(function (r) { return r.json(); })
        .then(function (d) { return (d.resources && d.resources.results && d.resources.results.products) || []; })
        .catch(function () { return []; });
    }

    var normalized = normalize(oq || q);
    var words = normalized.split(' ').filter(function (w) { return w.length >= 3; });
    var terms = [normalized].concat(words.length > 1 ? words : []);

    Promise.all(terms.map(suggest)).then(function (lists) {
      var seen = {}, products = [];
      lists.forEach(function (list) {
        list.forEach(function (p) { if (!seen[p.handle] && products.length < 8) { seen[p.handle] = 1; products.push(p); } });
      });
      if (!products.length) return;
      var html = '<h3 class="ds-fallback__title">You might be looking for</h3><ul class="ds-fallback__grid">';
      products.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        html += '<li><a href="' + p.url + '" class="ds-fallback__card">'
          + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy">' : '')
          + '<span class="ds-fallback__name"></span><span class="ds-fallback__price"></span></a></li>';
      });
      html += '</ul>';
      fallback.innerHTML = html;
      var cards = fallback.querySelectorAll('.ds-fallback__card');
      products.forEach(function (p, i) {
        cards[i].querySelector('.ds-fallback__name').textContent = p.title;
        if (p.price) cards[i].querySelector('.ds-fallback__price').textContent = '$' + parseFloat(p.price).toFixed(2);
      });
      fallback.hidden = false;
    });
  });
})();
